<template lang="pug">

  .main
    Header
    .header
      .img
        img(src="@assets/home/1.jpg")
      .logo
      .text-contain
        .text 唯品会旗下
        .text 专业代购批发平台
        .btns
          a(target="_blank" :href="appleUrl" @click="aclick(1)")
            .btn 下载IOS版 >
              .qrcode
                vue-qr(v-bind:text="appleUrl" :margin="10")
          a(target="_blank" v-bind:href="apkUrl" @click="aclick(2)")
            .btn.android 下载安卓版 >
              .qrcode
                vue-qr(v-bind:text="apkUrl" :margin="10")

    .common
      .img
        img(src="@assets/home/2.jpg")
      .about
        .title 关于唯代购
        .text 唯代购一边对接品牌方，提供第一手优质货源；另一边连接专业代购和批发商，通过快速组货、限时抢拍、一键播货、转发分销等形式快速拿货分销，打造一个高效率、低门槛线上平台。
    .common
      .img
        img(src="@assets/home/3.jpg")
    .common
      .img
        img(src="@assets/home/4.jpg")
    .common
      .img
        img(src="@assets/home/5.jpg")
    .common
      .img
        img(src="@assets/home/6.jpg")
    //.common.bottom


    <!--.gongzhonghao-->
      <!--img(src="@assets/home/gzh.png")-->
    //- .footer
    //-   .right Copyright © 2008-2018 vip.com，All Rights Reserved
    //-   .beian
    //-     a(href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010302111111" target="_blank") 粤公网安备 44010302111111号
    //-     a(href="https://beian.miit.gov.cn/" target="_blank")  粤ICP备08114786号

    <Footer />
</template>

<script>
import VueQr from 'vue-qr'
import mars from '@/lib/mars'
import api from '@/lib/api'
import Header from '@/components/PromotionHeader.vue'
import Footer from '@/components/PromotionFooter.vue'
import util from '@/utils'

export default {
  name: 'Home',
  data () {
    return {
      apkUrl: this.$globalConfig.apkUrl,
      appleUrl: this.$globalConfig.appleUrl
    }
  },
  components: {
    VueQr,
    Header,
    Footer
  },
  methods: {
    aclick(params) {
      if (params === 1) {
        mars.send('active_fenxiao_h5_official_web_IOS_download')
      } else {
        mars.send('active_fenxiao_h5_official_web_Android_download')
      }
    },
    getApkLink() {
      // 请求安卓下载链接
      api.getApkLink().then(res => {
        const data = res.data || {}
        const androidApkLink = data.androidApkLink 
        if (androidApkLink) {
          this.apkUrl = androidApkLink
        }
      })
    }
  },
  created() {
    util.setPCHtmlFontSize()
    mars.send('active_fenxiao_h5_p_official_web')
    this.getApkLink()

    this.$tracker.page('wdg_page_official_website', {
      page_id: 4 // behalf wholesale 代购批发
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
a,&:link, &:active, &:active,&:visited
  text-decoration none
  color inherit

.main
  max-width 1920px
  min-width 1280px
  margin auto
  font-size 0
  img
    width 100%
    height auto
  .header
    .logo
      position absolute
      top 0
      left 13.75%
      width 7.6525%
      height 10.625%
      background url("../assets/home/0.png") no-repeat top center
      background-size contain
    .text-contain
      font-size 72px
      color #fff
      line-height 90px
      position absolute
      left 13.75%
      top 20.15625%
      .btns
        position absolute
        .btn:hover
          .qrcode
            display block
        .btn
          background rgb(237,0,50)
          color #fff
          text-align center
          padding 0 15px
          height 65px
          font-size 28px
          font-weight normal
          font-stretch normal
          line-height 65px
          letter-spacing 0
          display inline-block
          vertical-align top
          margin 20px
          .qrcode
            position absolute
            display none
            background #fff
            width 250px
            height 250px
            top 80px
            left -400px
            right -400px
            margin auto
            div
              width 100%
              height 100%
              img
                width 100% !important
                height 100% !important
            &::before
              position absolute
              top -20px
              left 0
              right 0
              margin auto
              content ' '
              display block
              width 0
              height 0
              border 10px solid transparent
              border-bottom-color #fff
  .common
    .about
      position absolute
      width 480px
      right 8.32%
      bottom 180px
      .title
        font-size 72px
        font-weight normal
        font-stretch normal
        line-height 2rem
        letter-spacing 0
        color #333333
      .text
        font-size 24px
        margin-top 60px
        line-height 30px
        color #333
  .bottom
    background rgb(237,0,50)
    height 500px
    color #fff
  .gongzhonghao
    position fixed
    bottom 100px
    right 0
    background #fff
    width 10rem
    height 10rem
    img
      width 100%
      height 100%

  // .footer
  //   padding 20px 0
  //   background #ccc
  //   font-size 12px
  //   line-height 24px
  //   text-align center
  //   color #565656

</style>



// WEBPACK FOOTER //
// src/views/Home.vue